import React, { useState } from 'react';
import { Modal, Button } from 'semantic-ui-react';

export const DeleteSongVersion = ({
  openButton,
  onSuccess,
  instrumentMap,
  vtMap,
  version = null,
  songId = 0
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [spinnerActive, setSpinnerActive] = useState(false);
  const [displayError, setDisplayError] = useState(false);

  const handleDelete = () => {
    setSpinnerActive(true);
    setDisplayError(false);

    const message = {};

    Object.keys(version.version_info).forEach((key) => {
      message[key] = version.version_info[key];
    });

    message.ID = version.version_info.id;
    message.IsDeleted = true;

    console.log("Version being sent:", message);

    fetch(`/go/api/v1/song-versions/${message.ID}`, {
      method: "PUT",
      body: JSON.stringify(message),
      headers: {
        "Content-type": "application/json"
      },
      keepalive: true
    })
      .then((resp) => {
        if (resp.status === 200) {
          setDisplayError(false);

          setTimeout(() => {
            setModalOpen(false);
            setSpinnerActive(false);
            window.location.href = "/search";
          }, 3000);
        } else {
          setDisplayError(true);
          setSpinnerActive(false);
        }
      });
  };
  return (
    <Modal
      size="small"
      trigger={React.cloneElement(openButton, {
        onClick: () => {
          setDisplayError(false);
          setModalOpen(true);
        }
      })}
      open={modalOpen}
      onClose={() => {
        if (!spinnerActive) {
          setModalOpen(false);
        }
      }}
    >
      <Modal.Header>
        Delete Confirmation
      </Modal.Header>

      <Modal.Content>
        <p>
          Are you sure you want to delete this song version?
        </p>

        <p>
          This will remove the song version from the site and search results.
        </p>

        {displayError && (
          <p style={{ color: 'red' }}>
            There was an error deleting the song version.
            Please try again.
          </p>
        )}
      </Modal.Content>

      <Modal.Actions>
        <Button
          basic
          onClick={() => setModalOpen(false)}
          disabled={spinnerActive}
        >
          Cancel
        </Button>

        <Button
          color="red"
          loading={spinnerActive}
          disabled={spinnerActive}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
